import SelectedFilters from "./SelectedFilters";

export default SelectedFilters;
